module.exports = __webpack_public_path__ + "static/media/6.ac1a4a91.png";